import {
  OutgoingQuotationDto,
  OutgoingQuotationState,
  SaveOutgoingQuotationCommandRequest,
  SaveOutgoingQuotationCommandResponse,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { GetContext } from 'store/storeUtils'
import { OutgoingQuotationsController } from './OutgoingQuotationsController'

export class ProjectQuotationsController extends OutgoingQuotationsController {
  private readonly projectId: string

  constructor() {
    super()
    this.projectId = GetContext().projectId
  }

  public async getOutgoingQuotation(): Promise<OutgoingQuotationDto> {
    const existingResponse = (await this.list())
      .filter((quotation) => quotation.supplierProjectId === this.projectId)
      .sort(
        (left, right) => {
          const statePriority =
            Number(left.state === OutgoingQuotationState.Draft) -
            Number(right.state === OutgoingQuotationState.Draft)

          return (
            statePriority ||
            new Date(right.dateChanged ?? right.dateCreated ?? 0).getTime() -
              new Date(left.dateChanged ?? left.dateCreated ?? 0).getTime()
          )
        },
      )[0]

    if (existingResponse) {
      return existingResponse
    }

    const draft = await this.draft(this.projectId)
    return {
      id: draft.quotation.id,
       supplierProjectId: this.projectId,
       state: OutgoingQuotationState.Draft,
       quotation: draft.quotation,
    }
  }

  public saveOutgoingQuotation(
    request: SaveOutgoingQuotationCommandRequest,
  ): Promise<SaveOutgoingQuotationCommandResponse> {
    return this.save(request.outgoingQuotationId, request)
  }

  public sendOutgoingQuotation(quotationId: string): Promise<void> {
    return this.send(quotationId, this.projectId)
  }

  public deleteOutgoingQuotation(quotationId: string): Promise<void> {
    return this.delete(quotationId)
  }
}
